import React from 'react';

const DataProtectionIcon: React.FC = () => (
  <svg
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.22878 8.41056V6.25056C3.22878 3.88484 5.12708 1.96484 7.46607 1.96484C9.80505 1.96484 11.7034 3.88484 11.7034 6.25056V8.41056"
      stroke="#00223C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 8.41016H1.5V18.2502H13.5V8.41016Z"
      stroke="#00223C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49998 13.827C8.43606 13.827 9.1949 13.0595 9.1949 12.1127C9.1949 11.1659 8.43606 10.3984 7.49998 10.3984C6.56391 10.3984 5.80507 11.1659 5.80507 12.1127C5.80507 13.0595 6.56391 13.827 7.49998 13.827Z"
      stroke="#00223C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 14.0684V16.3655"
      stroke="#00223C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DataProtectionIcon;
